import React, { useCallback } from 'react';
import { AWAssetDto } from '@api/Api';
import Loader from '@components/Loader';
import { assetPreviewThumbnails } from '@helpers/assetPreviewThumbnails';

import './AssetPreview.less';
import { Tooltip } from 'antd';

type AssetPreviewProps = {
  asset: AWAssetDto;
};

export default function AssetPreview({ asset }: AssetPreviewProps) {
  const preview = useCallback(() => {
    return assetPreviewThumbnails({
      url: asset.previewUrl,
      status: 'ready',
      type: asset.type,
      size: 40,
      format: 'svg'
    });
  }, [asset.previewUrl, asset.type])();

  return (
    <div className="asset-preview">
      <div className="asset-preview_img">
        {preview === 'pending' && <Loader spinSize={24} isSpinning={true} />}
        {preview !== 'pending' ? (
          typeof preview === 'string' ? (
            <img src={preview || ''} alt="" />
          ) : (
            preview
          )
        ) : null}
      </div>
      <div className="asset-preview_info">
        <Tooltip
          title={`${asset.name}.${asset.extension}`}
          overlayClassName="approval-modal-tooltip"
          className="asset-preview_name"
        >
          {asset.name}
        </Tooltip>
        <div className="asset-preview_extension">.{asset.extension}</div>
      </div>
      <div className="asset-preview_version">v{asset.versionsCount}</div>
    </div>
  );
}
